import * as sellerLocationActionTypes from "./sellerLocationTypes";

const initialState = {
  createdSellerLocation: null,
  updatedSellerLocation: null,
  sellerLocations: [],
  supplierLists: [],
  loading: false,
};

const sellerLocationReducer = (state = initialState, action) => {
  switch (action.type) {
    case sellerLocationActionTypes.CREATE_SELLER_LOCATION:
      return {
        ...state,
        createdSellerLocation: action.value,
      };
    case sellerLocationActionTypes.UPDATE_SELLER_LOCATION:
      return {
        ...state,
        updateSellerLocation: action.value,
        sellerLocations: state.sellerLocations.map(location =>
          location._id === action.value._id ? action.value : location
        ),
      };
    case sellerLocationActionTypes.SET_SELLER_LOCATIONS:
      return {
        ...state,
        sellerLocations: action.value,
      };
    case sellerLocationActionTypes.GET_LOCATION_COUNTRIES:
      return {
        ...state,
        locationsContries: action.value,
      };
    case sellerLocationActionTypes.SET_SUPLIER_LIST:
      return {
        ...state,
        supplierLists: action.value,
      };
    case sellerLocationActionTypes.SET_SUPLIER_LOCATION_LIST:
      return {
        ...state,
        supplierLocationLists: action.value,
      };
    default:
      return state;
  }
};

export default sellerLocationReducer;